export default "__VITE_ASSET__sTIIDH7Q__"